import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './Image.module.scss';

const cx = classNames.bind(styles);

const Image = ({ width, height, src, placeholder, ...defaultProps }) => {
	const [isLoaded, setIsLoaded] = React.useState(false);

	return (
		<div className={styles.wrapper}>
			<img
				className={cx(styles.placeholder, { hide: isLoaded })}
				src={placeholder}
				alt=''
				width={width}
				height={height}
			/>

			<img
				className={cx(styles.image, { show: isLoaded })}
				src={src}
				alt=''
				width={width}
				height={height}
				onLoad={() => setIsLoaded(true)}
				loading='lazy'
				{...defaultProps}
			/>
		</div>
	);
};

Image.propTypes = {
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};

export default Image;
